import React from "react";
import PropTypes from "prop-types";
import styles from "./EventHeaderBar.module.css"; // Import CSS Module

const EventHeaderBar = ({ image, eventName, dateAndHour }) => {
  // Format the dateAndHour if it's a Date object
  const formattedDate = new Date(dateAndHour).toLocaleString();

  return (
    <div className={styles.eventHeaderBar}>
      <div className={styles.imageContainer}>
        <img
          src={image}
          alt={`Image for ${eventName}`}
          className={styles.eventImage}
          loading="lazy"
        />
      </div>
      <div className={styles.textContainer}>
        <h2 className={styles.eventName}>{eventName}</h2>
        <p className={styles.eventDate}>{formattedDate}</p>
      </div>
    </div>
  );
};

EventHeaderBar.propTypes = {
  image: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  dateAndHour: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]).isRequired
};

export default EventHeaderBar;
